import { gql } from "@apollo/client";

export const getMobileResponseQuery = gql`
  query GetMobileResponse($input: MobileServiceFilter!) {
    getMobileResponse(input: $input) {
      message
      response

    }
  }
`;

export const getAuditTrailByTaskIdQuery = gql`
  query GetAuditTrailByTaskId($taskId: String!) {
    getAuditTrailByTaskId(taskId: $taskId) {
      message
      response
    }
  }
`;

export const getMobileServiceNotesByTaskIdQuery = gql`
  query GetMobileServiceNotesByTaskId($taskId: String!) {
    getMobileServiceNotesByTaskId(taskId: $taskId) {
      message
      response
    }
  }
`;

export const getMobileResponseByIdQuery = gql`
  query GetMobileResponseById($responseId: String!) {
    getMobileResponseById(responseId: $responseId) {
      message
      response
    }
  }
`;

export const getCronGenerationLogsQuery = gql`
  query GetCronGenerationLogs($siteId: String, $from: String, $to: String, $page: Int, $pageSize: Int) {
    getCronGenerationLogs(siteId: $siteId, from: $from, to: $to, page: $page, pageSize: $pageSize) {
      message
      totalCount
      response
    }
  }
`;
